import { PebbleSelect } from 'components/ui';
import { Category } from 'types';
import classes from './SupplierActivitiesFilterDrawer.module.scss';

interface ISupplierCategoryFilter {
  categories: Category[];
  selectedCategoryId?: string;
  onSelect(val: string): void;
}

const SupplierCategoryFilter: React.FC<ISupplierCategoryFilter> = ({
  categories,
  selectedCategoryId,
  onSelect,
}) => {
  const options = categories.map((cat) => ({
    label: cat.name,
    value: cat.id,
  }));

  return (
    <PebbleSelect
      label="Category"
      placeholder="All categories"
      data={options}
      value={selectedCategoryId}
      onChange={(val) => {
        onSelect(val as string);
      }}
      classNames={{
        dropdown: classes.dropdown,
        input: classes.input,
        section: classes.rightSection,
        wrapper: classes.wrapper,
        option: classes.item,
        label: classes.selectLabel,
      }}
      clearable
      mt="sm"
    />
  );
};

export default SupplierCategoryFilter;
